import { toRefs, reactive, computed } from 'vue'
import { Message } from 'view-design'
import { getCustomStorage } from '@/components/custom-column-v2/utils.js'
import { getQueryCondition, addQueryCondition, delQueryCondition, savetemplate } from '@/api/ptom.data.model'

export function useCustomTableColumn(emits, { extendId, name: localstorageKey, menuId }) {
  let currCondition = null
  const templateModel = reactive({
    customColTemplateList: [],
    tableCustomColsRef: null,
    showCustomColumnConfigModal: false,
    activeTemplateId: ''
  })

  const customColTemplateListLength = computed(() => templateModel.customColTemplateList.length)

  const getCustomColTemplates = async () => {
    const conditions = await getQueryCondition({ menuId, extendId })

    if (conditions?.length) {
      templateModel.customColTemplateList = conditions.map((c) => ({ ...c, conditionInfo: JSON.parse(c.conditionInfo) })).map((c) => ({ ...c, conditionInfo: c.conditionInfo.columns }))
    }
    return Promise.resolve()
  }

  const addCustomColTemplate = async (name, columns) => {
    const res = await addQueryCondition({
      menuId,
      extendId,
      name,
      // 后端更新模板接口不支持数组的json，包裹一层传过去
      conditionInfo: JSON.stringify({ columns })
    })
    if (res) {
      getCustomColTemplates().then(getActiveTemplate)
    }
  }

  const removeCustomColTemplate = async (id) => {
    const data = await delQueryCondition({ id })
    if (data) {
      getCustomColTemplates().then(getActiveTemplate)
    }
  }

  /**
   * @description: 打开弹窗编辑
   * @param {*} condition
   * @return {*}
   */
  const updateCustomColTemplate = (condition) => {
    try {
      currCondition = condition
      const cols = condition.conditionInfo
      templateModel.showCustomColumnConfigModal = true
      templateModel.tableCustomColsRef.handleColsModify({ name: condition.name, cols })
    } catch (error) {
      console.log(' refill template error output: ', error)
    }
  }

  /**
   * @description: 更新模板
   * @param {*} modifyName
   * @param {*} columns
   * @return {*}
   */
  const updateCustomColTemplateAction = async (modifyName, columns) => {
    const { id } = currCondition
    const data = await savetemplate({
      id,
      name: modifyName,
      // 后端更新模板接口不支持数组的json，包裹一层传过去
      conditionInfo: { columns }
    })
    if (data) {
      getCustomColTemplates()
    }
  }

  /**
   * @description: 选择模版
   * @param {*} condition
   * @return {*}
   */
  function selectCustomTemplate(condition) {
    if (condition.conditionInfo?.length === 0) return
    const cols = condition.conditionInfo
    templateModel.tableCustomColsRef.handleColsTemplateSelect(cols)
    templateModel.activeTemplateId = condition.id
  }

  /**
   * @description: 自定义打开当前表格列
   * @return {*}
   */
  function showCustomModal() {
    templateModel.showCustomColumnConfigModal = true
  }

  function onCustomColumnChange({ columns, formatedCols, template }) {
    const { name, modifyName } = template || {}

    // 更新模板时不更改当前表格的列，有modifyName表示更新模板
    // 或者更新的是当前选中的模板，需要更新当前表格列
    if (!modifyName || (modifyName && templateModel.activeTemplateId === currCondition.id)) {
      emits('change', columns)
    }
    if (typeof name === 'string') {
      if (customColTemplateListLength.value >= 20) return Message.warning('最多保存20个模板')
      addCustomColTemplate(name, formatedCols)
    }
    if (typeof modifyName === 'string') {
      updateCustomColTemplateAction(modifyName, formatedCols)
    }
  }

  /**
   * @description: 比对当前本地存储的列，判断是否当前表格有选中的模板
   * @return {*}
   */
  function getActiveTemplate() {
    const localCol = getCustomStorage(localstorageKey)
    const condition = templateModel.customColTemplateList.find(c => JSON.stringify(c.conditionInfo) === JSON.stringify(localCol))
    templateModel.activeTemplateId = condition ? condition.id : ''
  }

  return {
    ...toRefs(templateModel),
    customColTemplateListLength,
    getCustomColTemplates,
    selectCustomTemplate,
    addCustomColTemplate,
    removeCustomColTemplate,
    updateCustomColTemplate,
    showCustomModal,
    getActiveTemplate,
    onCustomColumnChange
  }
}
